import { gql } from "@apollo/client";

const rateFields = `
  amount
  currency
  frequency
  symbol
`;

const userFields = `
  id
  name
  firstName
  lastName
  role
`;

const activityFields = `
  notification {
    required
    sent
    sentAt
    sentBy {
      ${userFields}
    }
  }
  lastTransitionActor {
    ${userFields}
  }
`;

const APPLICANT_RATE_FIELDS = gql`
  fragment ApplicantRateFields on MissionRoleApplicant {
    rate {
      ${rateFields}
    }
  }
`;

const APPLICANT_ACTIVITY_FIELDS = gql`
  fragment ApplicantActivityFields on MissionRoleApplicant {
    ${activityFields}
  }
`;

export { APPLICANT_RATE_FIELDS, APPLICANT_ACTIVITY_FIELDS };
